import { contextSrv } from 'app/core/services/context_srv';
import { AccessControlAction } from 'app/types/accessControl';

export const hasWritePermissions = () => {
  return contextSrv.hasPermission(AccessControlAction.QueriesWrite);
};

export const hasReadPermissions = () => {
  return contextSrv.hasPermission(AccessControlAction.QueriesRead);
};
